import React from 'react';
import styles from './usageSteps.module.scss';
import step1 from '../../../assets/images/IndexTutorial_step1.webp'
import step2 from '../../../assets/images/IndexTutorial_step2.webp'
import step3 from '../../../assets/images/IndexTutorial_step3.webp'

const usageSteps = () => (
  <div className={styles.wrapper}>
    <div className={[styles.container].join(' ')}>
      <div id="carouselExampleSlidesOnly" className="d-lg-block d-none carousel slide carousel-fade" data-ride="carousel" data-interval="1500" data-pause="false">
        <div className="carousel-inner">
          <div className="carousel-item active">
            <img className="d-block w-100" loading="lazy" src={step1} alt="龍寶寶三步驟之一"/>
          </div>
          <div className="carousel-item">
            <img className="d-block w-100" loading="lazy" src={step2} alt="龍寶寶三步驟之二"/>
          </div>
          <div className="carousel-item">
            <img className="d-block w-100" loading="lazy" src={step3} alt="龍寶寶三步驟之三"/>
          </div>
        </div>
      </div>
      <div id="carouselExampleSlidesOnly" className="d-lg-none d-block carousel slide carousel-fade" data-ride="carousel" data-interval="1500" data-pause="false">
        <div className="carousel-inner">
          <div className="carousel-item active">
            <img className="d-block w-100" src={step1} alt="龍寶寶三步驟之一"/>
          </div>
          <div className="carousel-item">
            <img className="d-block w-100" src={step2} alt="龍寶寶三步驟之二"/>
          </div>
          <div className="carousel-item">
            <img className="d-block w-100" src={step3} alt="龍寶寶三步驟之三"/>
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default usageSteps;
